"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incomeStatement = incomeStatement;
exports.balanceSheet = balanceSheet;
const money_1 = require("../money");
/**
 * اتجاه القراءة لكل قسم: الإيرادات والبنود الأخرى تُقرأ دائنًا ناقص مدين (الربح موجب)،
 * والتكلفة والمصروفات مدينًا ناقص دائن. فالحساب المقابل (مردودات مبيعات مثلاً) يظهر
 * سالبًا داخل قسمه وينقص مجموعه — بلا معالجة خاصة لكل حساب.
 */
function section(movements, accountClass, direction) {
    const rows = movements
        .filter((movement) => movement.accountClass === accountClass)
        .map((movement) => {
        const debit = money_1.Money.of(movement.debit);
        const credit = money_1.Money.of(movement.credit);
        const amount = (direction === 'credit' ? credit.sub(debit) : debit.sub(credit)).normalize();
        return { code: movement.code, nameAr: movement.nameAr, amount };
    })
        .filter((row) => !row.amount.isZero())
        .sort((a, b) => a.code.localeCompare(b.code));
    return { rows, total: money_1.Money.sum(rows.map((row) => row.amount)).normalize() };
}
/**
 * قائمة الدخل لفترة من حركة حسابات النتيجة فيها.
 *
 * صافى الربح = Σ(دائن − مدين) لكل حسابات PL، والتقسيم للعرض فقط — فلا يمكن أن
 * يختلف الصافى عن مجموع أقسامه، ولا عن أثر الفترة على الميزانية.
 */
function incomeStatement(movements) {
    const pl = movements.filter((movement) => movement.statement === 'PL');
    const revenue = section(pl, 'revenue', 'credit');
    const costOfSales = section(pl, 'cogs', 'debit');
    const expenses = section(pl, 'expense', 'debit');
    const other = section(pl, 'other', 'credit');
    const grossProfit = revenue.total.sub(costOfSales.total).normalize();
    const operatingProfit = grossProfit.sub(expenses.total).normalize();
    const netIncome = operatingProfit.add(other.total).normalize();
    return { revenue, costOfSales, grossProfit, expenses, operatingProfit, other, netIncome };
}
/** المركز المالى فى تاريخ من الحركة التراكمية لكل الحسابات حتى ذلك التاريخ. */
function balanceSheet(movements) {
    const bs = movements.filter((movement) => movement.statement === 'BS');
    const assets = section(bs, 'asset', 'debit');
    const liabilities = section(bs, 'liability', 'credit');
    const equity = section(bs, 'equity', 'credit');
    const unclosedResult = money_1.Money.sum(movements
        .filter((movement) => movement.statement === 'PL')
        .map((movement) => money_1.Money.of(movement.credit).sub(movement.debit))).normalize();
    const totalEquity = equity.total.add(unclosedResult).normalize();
    const totalLiabilitiesAndEquity = liabilities.total.add(totalEquity).normalize();
    return {
        assets,
        liabilities,
        equity,
        unclosedResult,
        totalEquity,
        totalLiabilitiesAndEquity,
        isBalanced: assets.total.eq(totalLiabilitiesAndEquity),
    };
}
//# sourceMappingURL=financial-statements.js.map